import { useNavigate } from "react-router-dom";

import { Text } from "@mantine/core";
import { Container, Grid, GridProps } from "@mui/material";

import { RouteList } from "../../lib/Routes";

import "./styles.scss";
import AnimateOnLoad from "../../components/AnimateOnLoad";

export default function Overview() {
  const navigate = useNavigate();
  const gridItemProps: GridProps = {
    item: true,
    className: "item",
    xl: 2.4,
    lg: 2.4,
    md: 3,
    sm: 4,
    xs: 6,
  };
  return (
    <AnimateOnLoad>
      <div className="overview-container flex-row justify-center">
        <Container maxWidth="lg">
          <Text className="component-header" tt="capitalize">
            Overview
          </Text>
          <br />
          <Grid container className="items">
            {RouteList.map((route) => {
              return (
                <Grid
                  key={route.label}
                  {...gridItemProps}
                  // @ts-ignore
                  onClick={() => {
                    navigate(`/dashboard/${route.link}`);
                  }}
                >
                  <route.icon size={40} stroke={1.2} color="var(--blue-primary)" />
                  <Text className="label">{route.label}</Text>
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </div>
    </AnimateOnLoad>
  );
}
